import React from "react";
import { Box, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
  /** Pass 'xs' | 'sm' | 'md' | 'lg' | 'xl' to cap width and center; false = full-bleed */
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
  /** Remove side padding entirely (useful inside cards/sliders) */
  disableGutters?: boolean;
};

const ResponsiveContainer = ({
  children,
  maxWidth = false,          // full width by default
  disableGutters = false,
}: Props) => {
  const theme = useTheme();
  const capPx = maxWidth ? `${theme.breakpoints.values[maxWidth]}px` : undefined;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: capPx,        // cap when provided
        mx: capPx ? "auto" : 0, // center only when capped
        px: disableGutters ? 0 : { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }, // responsive gutters
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveContainer;
